export default __webpack_public_path__ + "static/media/GF_FURY_Horizontal.b52b0b39.jpg";